<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-08-07',
        major: [],
        excepts: [],
        items: [


          // [NOTE] マスコット認定試験
          // ================================================================================

          item({
            collection  : 'MascotExam',
            id          : 'IR04-19',
            rare        : 'IR',
            name        : 'パレードイルミナージュドレス',
            imgUrl      : '/images/items/IR04-19.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'LP',
            type        : 'PR',
            point       : 1600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MascotExam',
            id          : 'IR02-10',
            rare        : 'IR',
            name        : 'パレードイルミナージュシューズ',
            imgUrl      : '/images/items/IR02-10.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'LP',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MascotExam',
            id          : 'IR03-10',
            rare        : 'IR',
            name        : 'パレードイルミナージュヘアアクセ',
            imgUrl      : '/images/items/IR03-10.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'LP',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MascotExam',
            rare        : 'IR',
          }),


          // [NOTE] しらゆきひめピンクコーデプレゼントキャンペーン
          // ================================================================================

          item({
            collection  : 'SnowWhitePink',
            id          : 'P-NC-006',
            rare        : 'HR',
            name        : 'しらゆきひめピンクワンピ',
            imgUrl      : '/images/items/P-NC-006-O.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SnowWhitePink',
            id          : 'P-NC-006-S',
            rare        : 'HR',
            name        : 'しらゆきひめピンクシューズ',
            imgUrl      : '/images/items/P-NC-006-S.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            aggregation : 'P-NC-006',
          }),
          item({
            collection  : 'SnowWhitePink',
            id          : 'P-NC-006-H',
            rare        : 'HR',
            name        : 'しらゆきひめピンクヘアアクセ',
            imgUrl      : '/images/items/P-NC-006-H.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            aggregation : 'P-NC-006',
          }),
          item({
            collection  : 'SnowWhitePink',
            rare        : 'HR',
          }),


          // [NOTE] ファイル キラッCHU＆キラッツ
          // ================================================================================

          item({
            collection  : 'KirachuFile',
            id          : 'AM-534',
            rare        : 'SR',
            name        : 'ファンシーレースアップブルートップス',
            imgUrl      : '/images/items/AM-534.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'KirachuFile',
            id          : 'AM-535',
            rare        : 'SR',
            name        : 'ファンシーレースアップブルースカート',
            imgUrl      : '/images/items/AM-535.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'KirachuFile',
            rare        : 'SR',
          }),
          item({
            collection  : 'KirachuFile',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケリフィル
          // ================================================================================

          item({
            collection  : 'NCRefill',
            id          : 'P-NC-004',
            rare        : 'SR',
            name        : 'ルミナスプラネットオレンジトップス',
            imgUrl      : '/images/items/P-NC-004-T.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'NCRefill',
            id          : 'P-NC-004-B',
            rare        : 'SR',
            name        : 'ルミナスプラネットオレンジスカート',
            imgUrl      : '/images/items/P-NC-004-B.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            aggregation : 'P-NC-004',
          }),
          item({
            collection  : 'NCRefill',
            id          : 'P-NC-004-S',
            rare        : 'SR',
            name        : 'ルミナスプラネットオレンジシューズ',
            imgUrl      : '/images/items/P-NC-004-S.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            aggregation : 'P-NC-004',
          }),
          item({
            collection  : 'NCRefill',
            id          : 'P-NC-004-H',
            rare        : 'SR',
            name        : 'ルミナスプラネットオレンジヘアアクセ',
            imgUrl      : '/images/items/P-NC-004-H.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            aggregation : 'P-NC-004',
          }),


          // [NOTE] ちゃお2020年5月号
          // ================================================================================

          item({
            collection  : 'Chao202005',
            id          : 'P-S-139',
            rare        : 'SR',
            name        : 'フラワーイースターオレンジトップス',
            imgUrl      : '/images/items/P-S-139.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-140',
            rare        : 'SR',
            name        : 'フラワーイースターオレンジスカート',
            imgUrl      : '/images/items/P-S-140.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-141',
            rare        : 'SR',
            name        : 'フラワーイースターオレンジシューズ',
            imgUrl      : '/images/items/P-S-141.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-142',
            rare        : 'SR',
            name        : 'フラワーイースターオレンジヘアアクセ',
            imgUrl      : '/images/items/P-S-142.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Chao202005',
            id          : 'P-S-143',
            rare        : 'SR',
            name        : 'ラビットカメオイエロートップス',
            imgUrl      : '/images/items/P-S-143.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-144',
            rare        : 'SR',
            name        : 'ラビットカメオイエロースカート',
            imgUrl      : '/images/items/P-S-144.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-145',
            rare        : 'SR',
            name        : 'ラビットカメオイエローシューズ',
            imgUrl      : '/images/items/P-S-145.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202005',
            id          : 'P-S-146',
            rare        : 'SR',
            name        : 'ラビットカメオイエローヘアアクセ',
            imgUrl      : '/images/items/P-S-146.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ちゃお2021年1月号
          // ================================================================================

          item({
            collection  : 'Chao202101',
            id          : 'P-NC-013',
            rare        : 'SR',
            name        : 'もりのりすピンクワンピ',
            imgUrl      : '/images/items/P-NC-013-O.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202101',
            id          : 'P-NC-013-S',
            rare        : 'SR',
            name        : 'もりのりすピンクシューズ',
            imgUrl      : '/images/items/P-NC-013-S.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            aggregation : 'P-NC-013'
          }),
          item({
            collection  : 'Chao202101',
            id          : 'P-NC-013-H',
            rare        : 'SR',
            name        : 'もりのりすピンクヘアアクセ',
            imgUrl      : '/images/items/P-NC-013-H.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            aggregation : 'P-NC-013'
          }),
          item({
            collection  : 'Chao202101',
            rare        : 'SR',
          }),


          item({
            collection  : 'Chao202101',
            id          : 'P-NC-014',
            rare        : 'SR',
            name        : 'ゆめみるおとめブルーワンピ',
            imgUrl      : '/images/items/P-NC-014-O.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao202101',
            id          : 'P-NC-014-S',
            rare        : 'SR',
            name        : 'ゆめみるおとめブルーシューズ',
            imgUrl      : '/images/items/P-NC-014-S.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            aggregation : 'P-NC-014'
          }),
          item({
            collection  : 'Chao202101',
            id          : 'P-NC-014-H',
            rare        : 'SR',
            name        : 'ゆめみるおとめブルーヘアアクセ',
            imgUrl      : '/images/items/P-NC-014-H.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            aggregation : 'P-NC-014'
          }),
          item({
            collection  : 'Chao202101',
            rare        : 'SR',
          }),


          // [NOTE]  ぷっちぐみ2020年10月号
          // ================================================================================

          item({
            collection  : 'PucchiGumi202010',
            id          : 'P-S-147',
            rare        : 'R',
            name        : 'ラブパトピンクツバサワンピ',
            imgUrl      : '/images/items/PT2-108.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PucchiGumi202010',
            id          : 'P-S-148',
            rare        : 'R',
            name        : 'ラブパトピンクツバサシューズ',
            imgUrl      : '/images/items/PT2-110.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PucchiGumi202010',
            id          : 'P-S-149',
            rare        : 'R',
            name        : 'ラブパトピンクツバサヘアアクセ',
            imgUrl      : '/images/items/PT2-109.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PucchiGumi202010',
            rare        : 'R',
          }),


          // [NOTE]  ぷっちぐみ2021年2月号
          // ================================================================================

          item({
            collection  : 'PucchiGumi202102',
            id          : 'P-NC-016',
            rare        : 'SR',
            name        : 'ラブパトシャインソラワンピ',
            imgUrl      : '/images/items/PT4-106.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PucchiGumi202102',
            id          : 'P-NC-016-S',
            rare        : 'SR',
            name        : 'ラブパトシャインソラシューズ',
            imgUrl      : '/images/items/PT4-107.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'P-NC-016',
          }),
          item({
            collection  : 'PucchiGumi202102',
            id          : 'P-NC-016-H',
            rare        : 'SR',
            name        : 'ラブパトシャインソラヘアアクセ',
            imgUrl      : '/images/items/PT4-108.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'P-NC-016',
          }),
          item({
            collection  : 'PucchiGumi202102',
            rare        : 'SR',
          }),


          // [NOTE] 公式ファンブックEgg1
          // ================================================================================

          item({
            collection  : 'FanbookEgg1',
            id          : 'P-S-134',
            rare        : 'SR',
            name        : 'クイーンオブハートパープルトップス',
            imgUrl      : '/images/items/P-S-134.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg1',
            id          : 'P-S-135',
            rare        : 'SR',
            name        : 'クイーンオブハートパープルスカート',
            imgUrl      : '/images/items/P-S-135.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg1',
            id          : 'P-S-136',
            rare        : 'SR',
            name        : 'クイーンオブハートパープルシューズ',
            imgUrl      : '/images/items/P-S-136.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg1',
            id          : 'P-S-137',
            rare        : 'SR',
            name        : 'クイーンオブハートパープルヘアアクセ',
            imgUrl      : '/images/items/P-S-137.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FanbookEgg1',
            id          : 'P-S-138',
            rare        : 'R',
            name        : 'さわやかハブラシ',
            imgUrl      : '/images/items/P-S-138.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg1',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'FanbookEgg1',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'FanbookEgg1',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] 公式ファンブックEgg2•3
          // ================================================================================

          item({
            collection  : 'FanbookEgg2-3',
            id          : 'P-NC-012',
            rare        : 'SR',
            name        : 'サイバーキャットレッドトップス',
            imgUrl      : '/images/items/P-NC-012-T.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg2-3',
            id          : 'P-NC-012-B',
            rare        : 'SR',
            name        : 'サイバーキャットレッドスカート',
            imgUrl      : '/images/items/P-NC-012-B.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            aggregation : 'P-NC-012',
          }),
          item({
            collection  : 'FanbookEgg2-3',
            id          : 'P-NC-012-S',
            rare        : 'SR',
            name        : 'サイバーキャットレッドシューズ',
            imgUrl      : '/images/items/P-NC-012-S.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            aggregation : 'P-NC-012',
          }),
          item({
            collection  : 'FanbookEgg2-3',
            id          : 'P-NC-012-H',
            rare        : 'SR',
            name        : 'サイバーキャットレッドヘアアクセ',
            imgUrl      : '/images/items/P-NC-012-H.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            aggregation : 'P-NC-012',
          }),


          item({
            collection  : 'FanbookEgg2-3',
            id          : 'P-S-150',
            rare        : 'R',
            name        : 'マシュマロたっぷりスモアピザ',
            imgUrl      : '/images/items/P-S-150.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg2-3',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'FanbookEgg2-3',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'FanbookEgg2-3',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] 公式ファンブックEgg4
          // ================================================================================

          item({
            collection  : 'FanbookEgg4',
            id          : 'P-NC-017',
            rare        : 'SR',
            name        : 'いたずらナイトメアグリーントップス',
            imgUrl      : '/images/items/P-NC-017-T.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg4',
            id          : 'P-NC-017-B',
            rare        : 'SR',
            name        : 'いたずらナイトメアグリーンスカート',
            imgUrl      : '/images/items/P-NC-017-B.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            aggregation : 'P-NC-017',
          }),
          item({
            collection  : 'FanbookEgg4',
            id          : 'P-NC-017-S',
            rare        : 'SR',
            name        : 'いたずらナイトメアグリーンシューズ',
            imgUrl      : '/images/items/P-NC-017-S.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'P-NC-017',
          }),
          item({
            collection  : 'FanbookEgg4',
            id          : 'P-NC-017-H',
            rare        : 'SR',
            name        : 'いたずらナイトメアグリーンヘアアクセ',
            imgUrl      : '/images/items/P-NC-017-H.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            aggregation : 'P-NC-017',
          }),


          // [NOTE] 公式ファンブックEgg5
          // ================================================================================

          item({
            collection  : 'FanbookEgg5',
            id          : 'P-NC-018',
            rare        : 'SR',
            name        : 'テディベアポップイエロートップス',
            imgUrl      : '/images/items/P-NC-018-T.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg5',
            id          : 'P-NC-018-B',
            rare        : 'SR',
            name        : 'テディベアポップイエローパンツ',
            imgUrl      : '/images/items/P-NC-018-B.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            aggregation : 'P-NC-018',
          }),
          item({
            collection  : 'FanbookEgg5',
            id          : 'P-NC-018-S',
            rare        : 'SR',
            name        : 'テディベアポップイエローシューズ',
            imgUrl      : '/images/items/P-NC-018-S.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            aggregation : 'P-NC-018',
          }),
          item({
            collection  : 'FanbookEgg5',
            id          : 'P-NC-018-H',
            rare        : 'SR',
            name        : 'テディベアポップイエローヘアアクセ',
            imgUrl      : '/images/items/P-NC-018-H.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            aggregation : 'P-NC-018',
          }),


          // [NOTE] 公式ファンブックEgg6
          // ================================================================================

          item({
            collection  : 'FanbookEgg6',
            id          : 'P-NC-019',
            rare        : 'SR',
            name        : 'パーフェクトシャインノーブルトップス',
            imgUrl      : '/images/items/P-NC-019-T.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FanbookEgg6',
            id          : 'P-NC-019-B',
            rare        : 'SR',
            name        : 'パーフェクトシャインノーブルパンツ',
            imgUrl      : '/images/items/P-NC-019-B.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'LP',
            type        : 'NT',
            point       : 750,
            aggregation : 'P-NC-019',
          }),
          item({
            collection  : 'FanbookEgg6',
            id          : 'P-NC-019-S',
            rare        : 'SR',
            name        : 'パーフェクトシャインノーブルシューズ',
            imgUrl      : '/images/items/P-NC-019-S.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'LP',
            type        : 'NT',
            point       : 700,
            aggregation : 'P-NC-019',
          }),
          item({
            collection  : 'FanbookEgg6',
            id          : 'P-NC-019-H',
            rare        : 'SR',
            name        : 'パーフェクトシャインノーブルヘアアクセ',
            imgUrl      : '/images/items/P-NC-019-H.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 700,
            aggregation : 'P-NC-019',
          }),


          // [NOTE] プリズムストーン 2020年夏ノベルティプリチケ
          // ================================================================================

          item({
            collection  : 'PS2020Summer',
            id          : 'P-205',
            rare        : 'SR',
            name        : 'ハッピーバルーンブルートップス',
            imgUrl      : '/images/items/P-205.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Summer',
            id          : 'P-206',
            rare        : 'SR',
            name        : 'ハッピーバルーンブルースカート',
            imgUrl      : '/images/items/P-206.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Summer',
            id          : 'P-207',
            rare        : 'SR',
            name        : 'ハッピーバルーンブルーシューズ',
            imgUrl      : '/images/items/P-207.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Summer',
            id          : 'P-208',
            rare        : 'SR',
            name        : 'ハッピーバルーンブルーヘアアクセ',
            imgUrl      : '/images/items/P-208.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリズムストーン 2020年秋ノベルティプリチケ
          // ================================================================================

          item({
            collection  : 'PS2020Autumn',
            id          : 'P-209',
            rare        : 'SR',
            name        : 'アンティークリボングリーントップス',
            imgUrl      : '/images/items/P-209.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Autumn',
            id          : 'P-210',
            rare        : 'SR',
            name        : 'アンティークリボングリーンスカート',
            imgUrl      : '/images/items/P-210.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Autumn',
            id          : 'P-211',
            rare        : 'SR',
            name        : 'アンティークリボングリーンシューズ',
            imgUrl      : '/images/items/P-211.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Autumn',
            id          : 'P-212',
            rare        : 'SR',
            name        : 'アンティークリボングリーンヘアアクセ',
            imgUrl      : '/images/items/P-212.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリズムストーン 2020年冬ノベルティプリチケ
          // ================================================================================

          item({
            collection  : 'PS2020Winter',
            id          : 'P-213',
            rare        : 'SR',
            name        : 'アメリカンダイナーパープルトップス',
            imgUrl      : '/images/items/P-213.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-214',
            rare        : 'SR',
            name        : 'アメリカンダイナーパープルスカート',
            imgUrl      : '/images/items/P-214.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-215',
            rare        : 'SR',
            name        : 'アメリカンダイナーパープルシューズ',
            imgUrl      : '/images/items/P-215.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-216',
            rare        : 'SR',
            name        : 'アメリカンダイナーパープルヘアアクセ',
            imgUrl      : '/images/items/P-216.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PS2020Winter',
            id          : 'P-221',
            rare        : 'SR',
            name        : 'ファンタジースノーオレンジトップス',
            imgUrl      : '/images/items/P-221.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-222',
            rare        : 'SR',
            name        : 'ファンタジースノーオレンジスカート',
            imgUrl      : '/images/items/P-222.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-223',
            rare        : 'SR',
            name        : 'ファンタジースノーオレンジシューズ',
            imgUrl      : '/images/items/P-223.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2020Winter',
            id          : 'P-224',
            rare        : 'SR',
            name        : 'ファンタジースノーオレンジヘアアクセ',
            imgUrl      : '/images/items/P-224.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリズムストーン 2021年春ノベルティプリチケ
          // ================================================================================

          item({
            collection  : 'PS2021Spring',
            id          : 'P-201',
            rare        : 'SR',
            name        : 'クイーンオブハートブルートップス',
            imgUrl      : '/images/items/P-201.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2021Spring',
            id          : 'P-202',
            rare        : 'SR',
            name        : 'クイーンオブハートブルースカート',
            imgUrl      : '/images/items/P-202.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2021Spring',
            id          : 'P-203',
            rare        : 'SR',
            name        : 'クイーンオブハートブルーシューズ',
            imgUrl      : '/images/items/P-203.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2021Spring',
            id          : 'P-204',
            rare        : 'SR',
            name        : 'クイーンオブハートブルーヘアアクセ',
            imgUrl      : '/images/items/P-204.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] マクドナルドハッピーセット「リカちゃん」
          // ================================================================================

          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-004',
            rare        : 'SR',
            name        : 'シンデレラリカちゃんドレス',
            imgUrl      : '/images/items/MC-004.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-005',
            rare        : 'SR',
            name        : 'シンデレラリカちゃんシューズ',
            imgUrl      : '/images/items/MC-005.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-006',
            rare        : 'SR',
            name        : 'シンデレラリカちゃんヘアアクセ',
            imgUrl      : '/images/items/MC-006.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'HappySetLicca2020',
            rare        : 'SR',
          }),


          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-007',
            rare        : 'R',
            name        : 'ジュエリーコスメパープルトップス',
            imgUrl      : '/images/items/MC-007.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-008',
            rare        : 'R',
            name        : 'ジュエリーコスメパープルスカート',
            imgUrl      : '/images/items/MC-008.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            aggregation : 'MC-007',
          }),
          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-009',
            rare        : 'R',
            name        : 'ジュエリーコスメパープルシューズ',
            imgUrl      : '/images/items/MC-009.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'HappySetLicca2020',
            id          : 'MC-010',
            rare        : 'R',
            name        : 'ジュエリーコスメパープルヘアアクセ',
            imgUrl      : '/images/items/MC-010.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] キラッとプリ☆チャンシーズン3 BD/DVD BOX1
          // ================================================================================

          item({
            collection  : 'DVDBOX-S3-1',
            id          : 'P-217',
            rare        : 'SR',
            name        : 'マスコットキラッCHUゴシックトップス',
            imgUrl      : '/images/items/P-217.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX-S3-1',
            id          : 'P-218',
            rare        : 'SR',
            name        : 'マスコットキラッCHUゴシックスカート',
            imgUrl      : '/images/items/P-218.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX-S3-1',
            id          : 'P-219',
            rare        : 'SR',
            name        : 'マスコットキラッCHUゴシックシューズ',
            imgUrl      : '/images/items/P-219.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX-S3-1',
            id          : 'P-220',
            rare        : 'SR',
            name        : 'マスコットキラッCHUゴシックヘアアクセ',
            imgUrl      : '/images/items/P-220.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


        ]
      }
    },

    methods: {
      collection (collection = '') {
        return _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="マスコット認定試験" color="#edd50f" :items="collection('MascotExam')" />
      <ItemList title="しらゆきひめピンクコーデ|プレゼントキャンペーン" color="#ff5d91" :items="collection('SnowWhitePink')" />
      <ItemList title="プリ☆チャンファイル|キラッCHU＆キラッツ" color="#ffa1bc" :items="collection('KirachuFile')" />
      <ItemList title="プリ☆チャン|ニコチケリフィル" color="#ffa1bc" :items="collection('NCRefill')" />
    </template>

    <template #col2>
      <ItemList title="ちゃお2020年5月号" color="#ffa1bc" :items="collection('Chao202005')" />
      <ItemList title="ちゃお2021年1月号" color="#ffa1bc" :items="collection('Chao202101')" />
      <ItemList title="ぷっちぐみ2020年10月号" color="#ffa1bc" :items="collection('PucchiGumi202010')" />
      <ItemList title="ぷっちぐみ2021年2月号" color="#ffa1bc" :items="collection('PucchiGumi202102')" />
    </template>

    <template #col3>
      <ItemList title="ファンブックEgg1" color="#ffa1bc" :items="collection('FanbookEgg1')" />
      <ItemList title="ファンブックEgg2•3" color="#ffa1bc" :items="collection('FanbookEgg2-3')" />
      <ItemList title="ファンブックEgg4" color="#ffa1bc" :items="collection('FanbookEgg4')" />
      <ItemList title="ファンブックEgg5" color="#ffa1bc" :items="collection('FanbookEgg5')" />
      <ItemList title="ファンブックEgg6" color="#ffa1bc" :items="collection('FanbookEgg6')" />
    </template>

    <template #col4>
      <ItemList title="プリズムストーン2020年夏|ノベルティプリチケ" color="#00c7da" :items="collection('PS2020Summer')" />
      <ItemList title="プリズムストーン2020年秋|ノベルティプリチケ" color="#00c7da" :items="collection('PS2020Autumn')" />
      <ItemList title="プリズムストーン2020年冬|ノベルティプリチケ" color="#00c7da" :items="collection('PS2020Winter')" />
      <ItemList title="プリズムストーン2021年春|ノベルティプリチケ" color="#00c7da" :items="collection('PS2021Spring')" />
    </template>

    <template #col5>
      <ItemList title="マクドナルドハッピーセット|リカちゃん" color="#ffa1bc" :items="collection('HappySetLicca2020')" />
      <ItemList title="シーズン3 BD/DVD BOX1" color="#ffa1bc" :items="collection('DVDBOX-S3-1')" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
